const SET_QUOTE = 'mrCollection/SET_QUOTE';
const CLEAN_QUOTE = 'mrCollection/CLEAN_QUOTE';

const SET_QUOTE_ERROR = 'mrCollection/SET_QUOTE_ERROR';
const CLEAN_QUOTE_ERROR = 'mrCollection/CLEAN_QUOTE_ERROR';

export default {
  SET_QUOTE,
  CLEAN_QUOTE,

  SET_QUOTE_ERROR,
  CLEAN_QUOTE_ERROR,
};
